import type { IndustryDto as IndustryDtoCrm } from '@/services/ws-crm/src/main/resources/rest-api';
import { type IndustryDto as IndustryDtoSelfBooking, type AdvertiserDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';

import type { Option } from 'src/types';
import { LanguageKey } from 'src/types';

export const selectedFilterOptions = <T>(allOptions: Option<T>[], selectedIds?: T[]): Option<T>[] =>
  selectedIds ? allOptions.filter((option) => selectedIds.includes(option.value)) : [];

export const formatIndustryOptionLabel = (industry: IndustryDtoCrm | IndustryDtoSelfBooking, language: string) => {
  if (language === LanguageKey.German) {
    return industry.nameDe ?? '';
  }
  if (language === LanguageKey.French) {
    return industry.nameFr ?? '';
  }
  if (language === LanguageKey.Italian) {
    return industry.nameIt ?? '';
  }
  return industry.nameEn ?? '';
};

export const formatSelfBookingAdvertiserOptionLabel = (advertiser: AdvertiserDto | string, language: string) => {
  return typeof advertiser === 'string' ? advertiser : `${advertiser.name} (${formatIndustryOptionLabel(advertiser.industry, language)})`;
};
